enum GuestAnalyticsGroupType {
  firstTimeUser = "初回利用客",
  yochiyochi = "よちよち客",
  kotsukotsu = "コツコツ客",
  trendyUser = "流行客",
  royalUser = "優良客",
}

export default GuestAnalyticsGroupType;
